import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

type sloaderprops = {
  color: string;
};

const SmallLoader = ({ color }: sloaderprops) => {
  return (
    <div className={`flex justify-center items-center`}>
      <div>
        <Box sx={{ display: "flex" }}>
          <CircularProgress
            size={18}
            sx={{ color: `${color ? "white" : "black"}` }}
          />
        </Box>
      </div>
    </div>
  );
};

export default SmallLoader;
